/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType;
(function (FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType) {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType[FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType["Unspecified"] = 0] = "Unspecified";
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType[FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType["Steam"] = 1] = "Steam";
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType[FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType["Egs"] = 2] = "Egs";
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType[FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType["Google"] = 3] = "Google";
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType[FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType["Facebook"] = 4] = "Facebook";
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType[FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType["SteamOpenId"] = 5] = "SteamOpenId";
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType[FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType["Aw"] = 6] = "Aw";
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType[FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType["VkId"] = 7] = "VkId";
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType[FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType["AuthenticateWithExternalIdGameAccessToken"] = 100] = "AuthenticateWithExternalIdGameAccessToken";
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType[FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType || (FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType = {}));
export function instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType(value) {
    for (const key in FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType) {
        if (Object.prototype.hasOwnProperty.call(FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType, key)) {
            if (FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeToJSON(value) {
    return value;
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType.js.map